import * as React from 'react'
import { BaseIconProps } from '../../types'

function SvgError({ size = '24', color = '#666', ...props }: BaseIconProps) {
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none" {...props}>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12 2C6.477 2 2 6.477 2 12s4.477 10 10 10 10-4.477 10-10S17.523 2 12 2zm0 2a8 8 0 110 16 8 8 0 010-16zm0 10a1 1 0 001-1V7a1 1 0 10-2 0v6a1 1 0 001 1zm0 2a1 1 0 100 2 1 1 0 000-2z"
        fill={color}
      />
    </svg>
  )
}

export default SvgError
